import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54d2a776")

_pushScopeId("data-v-54d2a776")
const _hoisted_1 = {
  key: 0,
  class: "level-box"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("저수율 : ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_6 = /*#__PURE__*/_createVNode("li", null, "------------------------", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("수위 : ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.waterLevel!=null)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h4", null, [
            _createVNode("span", {
              textContent: _toDisplayString(_ctx.waterLevel.name)
            }, null, 8, ["textContent"])
          ]),
          _createVNode("ul", null, [
            _createVNode("li", null, [
              _hoisted_3,
              _createVNode("span", {
                textContent: _toDisplayString(_ctx.waterLevel.reservoir_rate)
              }, null, 8, ["textContent"]),
              _hoisted_4,
              _createVNode("span", {
                textContent: _toDisplayString(_ctx.waterLevel.contrast_ratio)
              }, null, 8, ["textContent"]),
              _hoisted_5
            ]),
            _hoisted_6,
            _createVNode("li", null, [
              _hoisted_7,
              _createVNode("span", {
                textContent: _toDisplayString(_ctx.waterLevel.water_height)
              }, null, 8, ["textContent"])
            ])
          ])
        ]),
        _createVNode("div", {
          class: "background",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupAction()))
        })
      ]))
    : _createCommentVNode("", true)
})